export default {
    plans(state) {
        return state.plans;
    },
    error(state) {
        return state.error;
    },
    materials(state) {
        return state.materials;
    }
};
